// base styles
import colors from "assets/mavric-theme/base/colors";
import boxShadows from "assets/mavric-theme/base/boxShadows";
import borders from "assets/mavric-theme/base/borders";

const { primary } = colors;
const { md } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: primary.main,
      boxShadow: md,
      //borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
